import { ApolloLink } from 'apollo-link'
import { HttpLink } from 'apollo-link-http'
import { Auth, getIsAuthenticated, getJwtToken } from '@edge/spark/io-aws'
import { AuthOptions, AUTH_TYPE, createAuthLink } from 'aws-appsync-auth-link'
import { onError } from 'apollo-link-error'
import { env } from '@edge/env'

const region = env.REACT_APP_COGNITO_REGION
const url = env.REACT_APP_GRAPHQL_URI

if (!region || !url) {
    console.error('Spark Environment variables not defined')
}

const httpLink = new HttpLink({ uri: url })

const errorLink = onError(({ graphQLErrors, networkError, ...rest }) => {
    if (graphQLErrors)
        graphQLErrors.map(({ message, locations, path }) =>
            console.error(`[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`),
        )

    if (networkError) {
        console.error(`[Network error]: ${networkError}`)
    }

    if (!graphQLErrors && !networkError) {
        console.error(`[Apollo error]`, rest)
    }
})

const auth: AuthOptions = {
    type: AUTH_TYPE.AMAZON_COGNITO_USER_POOLS,
    jwtToken: async () => {
        try {
            const isAuthed = await getIsAuthenticated()

            if (!isAuthed) {
                return ''
            }

            const token = await getJwtToken()
            if (!token) {
                console.error('sparkLink isAuthenticated but no token. Signing out...')
                await Auth.signOut()
                return ''
            }

            return token
        } catch (e) {
            console.error('sparkLink Error. Signing out...', e)
            await Auth.signOut()
            return ''
        }
    },
}

export const sparkLink =
    url && region
        ? ApolloLink.from([
              errorLink,
              // @ts-expect-error why?
              createAuthLink({
                  url,
                  region,
                  auth,
              }),
              httpLink,
          ])
        : ApolloLink.from([errorLink])
